import React from "react";
import UploadCamera from "components/UploadCamera";
import UploadFile from "components/UploadFile";

export default function Step5CetatenieRoman({ setFieldValue, formikValues, formikErrors, formikTouched }) {
   return (
      <div className="row text-center mt-50">
         <UploadCamera fileName={"buletinPhoto.jpeg"} name={"fileCI"} setFieldValue={setFieldValue} />
         <UploadFile
            name={"fileCI"}
            setFieldValue={setFieldValue}
            value={formikValues.fileCI}
            error={formikErrors.fileCI}
            touched={formikTouched.fileCI}
         />
      </div>
   );
}
